import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';
import { compStatusTypes } from '../../Constants';

class Progress extends BaseComponent {
    getIndicatorClassName() {
        return `entryLmsIndicator ${this.props.indicatorStatus}`;
    }

    render() {
        const progressValue =
            ((this.props.nowValue + 1) * 100) / this.props.maxValue;
        return (
            <div className="entryLmsProgress">
                <div className="entryLmsProgressBackground">
                    <div
                        className="entryLmsProgressBar"
                        style={{
                            width: `${progressValue}%`,
                        }}
                    />
                </div>
                <div className="entryLmsIndicatorView">
                    <div className={this.getIndicatorClassName()}>
                        {this.props.nowValue + 1}/{this.props.maxValue}
                    </div>
                </div>
            </div>
        );
    }
}

Progress.displayName = 'Progress';
Progress.propTypes = {
    nowValue: PropTypes.number.isRequired,
    maxValue: PropTypes.number.isRequired,
    progressStatus: PropTypes.oneOf(Object.keys(compStatusTypes)),
    indicatorStatus: PropTypes.oneOf(Object.keys(compStatusTypes)),
};

export default Progress;



// WEBPACK FOOTER //
// ./components/CommonSet/Progress.js